
/* after resize adjust yAxes sizes
*/
export function setAxisSize (H) {
  H.wrap(H.Axis.prototype, 'setAxisSize', function (proceed) {
    const pick = H.pick;
    const mathMax = Math.max;
    const chart = this.chart;
    const options = this.options;
    const offsetLeft = options.offsetLeft || 0;
    const offsetRight = options.offsetRight || 0;
    const horiz = this.horiz;
    let width = pick(options.width, chart.plotWidth - offsetLeft + offsetRight);
    let height = pick(options.height, chart.plotHeight);
    let top = pick(options.top, chart.plotTop);
    let left = pick(options.left, chart.plotLeft + offsetLeft);
    const percentRegex = /%$/;

    // Check for percentage based input values
    if (percentRegex.test(height)) {
      height = parseFloat(height) / 100 * chart.plotHeight;
    }
    if (percentRegex.test(top)) {
      top = parseFloat(top) / 100 * chart.plotHeight + chart.plotTop;
    }
    //* ********************************************************new code start
    if (percentRegex.test(width)) {
      width = parseFloat(width) / 100 * (chart.plotWidth - offsetLeft + offsetRight);
    }
    if (percentRegex.test(left)) {
      left = parseFloat(left) / 100 * chart.plotWidth + chart.plotLeft;
    }
    //* ********************************************************end new code

    // Expose basic values to use in Series object and navigator
    this.left = left;
    this.top = top;
    this.width = width;
    this.height = height;
    this.bottom = chart.chartHeight - height - top;
    this.right = chart.chartWidth - width - left;

    // Direction agnostic properties
    this.len = mathMax(horiz ? width : height, 0); // mathMax fixes #905
    this.pos = horiz ? left : top; // distance from SVG origin
    // },
  });
}
export function breakAxisWrap (H) {
  H.wrap(H.Axis.prototype, 'getLinePath', function (proceed, lineWidth) {
    const axis = this;
    const brokenAxis = axis.brokenAxis;
    const path = proceed.call(this, lineWidth);
    const start = path[0];
    let x = start[1];
    let y = start[2];

    (brokenAxis.breakArray || []).forEach(function (brk) {
      if (axis.horiz) { /* don't show  slanted line  on X axis */
        x = axis.toPixels(brk.from);
        path.splice(1, 0,
          ['L', x - 4, y], // stop
          ['M', x - 9, y + 5],
          // ['L', x + 1, y - 5], // left slanted line
          ['M', x - 1, y + 5],
          // ['L', x + 9, y - 5], // higher slanted line
          ['M', x + 4, y]
        );
      } else {
        y = axis.toPixels(brk.from);
        path.splice(1, 0,
          ['L', x, y - 4], // stop
          ['M', x + 5, y - 9],
          ['L', x - 5, y + 1], // lower slanted line
          ['M', x + 5, y - 1],
          ['L', x - 5, y + 9], // higher slanted line
          ['M', x, y + 4]
        );
      }
    });
    return path;
  });
}
